var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.generatePdf}},[_vm._v(_vm._s(_vm.schema.buttonLabel))])}
var staticRenderFns = []

export { render, staticRenderFns }